export const translations = {
  it: {
    nav: {
      story: "Storia",
      manifesto: "Manifesto",
      gallery: "Galleria",
      contact: "Contatti",
      langLabel: "IT / EN",
    },
    hero: {
      eyebrow: "Un cimelio unico · Roma, Italia",
      title1: "Ventidue firme.",
      title2: "Uno scudetto.",
      title3: "Un'unica fotografia.",
      lede: "La rosa completa dell'AS Roma 1982/83 — allenatori, staff e giocatori — firmata a mano su una singola stampa d'epoca. Custodita a Roma da oltre quarant'anni.",
      cta: "Richiedi informazioni",
      scroll: "Scorri per scoprire",
    },
    marquee: "Un cimelio irripetibile — An irreplaceable relic — 1982/83 — Roma Campione d'Italia — ",
    manifesto: {
      eyebrow: "Il manifesto",
      title: "Cinque capitoli su una fotografia che non può più esistere.",
      chapters: [
        {
          n: "01",
          title: "L'oggetto",
          body: "Una stampa fotografica ufficiale della stagione 1982/83, incorniciata e mai duplicata. Sul fronte, la squadra al completo posa davanti all'obiettivo di Foto Crescenzi. Attorno ai volti, ventidue autografi originali, tracciati in inchiostro nero direttamente sulla superficie fotografica.",
        },
        {
          n: "02",
          title: "Lo scudetto",
          body: "8 maggio 1983. La Roma di Nils Liedholm conquista il secondo scudetto della sua storia, quarantuno anni dopo il primo. Falcão orchestra il centrocampo, Bruno Conti disegna traiettorie sulle fasce, Agostino Di Bartolomei porta la fascia. Undici partite senza sconfitta chiudono il campionato.",
        },
        {
          n: "03",
          title: "Le firme",
          body: "Ogni giocatore, ogni allenatore, ogni membro dello staff tecnico ha firmato personalmente questa fotografia. Liedholm, Di Bartolomei, Falcão, Pruzzo, Bruno Conti, Ancelotti, Tancredi — una lista che oggi contiene nomi che non possono più essere aggiunti a nulla.",
        },
        {
          n: "04",
          title: "La provenienza",
          body: "La fotografia è appesa in una casa privata a Roma dal decennio successivo al trionfo. Nessuna riproduzione autografata è stata realizzata. Non esiste un secondo esemplare identico — le firme sono l'impronta irripetibile di un momento storico.",
        },
        {
          n: "05",
          title: "L'unicità",
          body: "Con la scomparsa di alcuni protagonisti — Di Bartolomei, Liedholm, Vierchowod, Sébastien — questo esemplare è definitivamente irripetibile. Non è una stampa firmata: è l'unica stampa che riunisce tutte queste firme insieme.",
        },
      ],
    },
    gallery: {
      eyebrow: "Galleria",
      title: "Cinque prospettive sulla stessa reliquia.",
      captions: [
        "Vista frontale · La cornice completa",
        "Dettaglio · Terza fila e panchina",
        "Vista superiore · Firme dei titolari",
        "Composizione integrale · Cornice in legno",
        "Vista laterale · Firme in evidenza",
      ],
    },
    signatures: {
      eyebrow: "I firmatari",
      title: "Undici titolari, la panchina, l'allenatore. La rosa completa.",
      players: [
        "Franco Tancredi",
        "Sebino Nela",
        "Aldo Maldera",
        "Herbert Prohaska",
        "Michele Nappi",
        "Pietro Vierchowod",
        "Carlo Ancelotti",
        "Agostino Di Bartolomei",
        "Bruno Conti",
        "Roberto Pruzzo",
        "Paulo Roberto Falcão",
        "Odoacre Chierico",
        "Maurizio Iorio",
        "Ubaldo Righetti",
        "Franco Superchi",
        "Diego Bortoluzzi",
        "Stefano Desideri",
      ],
      staff: [
        "Nils Liedholm — Allenatore",
        "Ezio Sella — Vice",
        "Giorgio Tessari — All. secondo",
        "Ernesto Colucci — Prep. Atletico",
        "Dr. Alicicco — Medico Sociale",
      ],
    },
    contact: {
      eyebrow: "Contatti",
      title: "Per collezionisti seri.",
      body: "Se sei interessato ad acquisire questo cimelio, o vuoi ricevere informazioni riservate su provenienza, autenticazione e condizioni, scrivimi. Rispondo personalmente a ogni messaggio.",
      recipient: "francesco@cynopia.com",
      form: {
        name: "Nome e cognome",
        email: "Email",
        phone: "Cellulare",
        message: "Il tuo messaggio",
        submit: "Invia richiesta",
        submitting: "Invio in corso…",
        success: "Grazie. Ti risponderò al più presto.",
        error: "Qualcosa è andato storto. Riprova tra qualche istante.",
      },
    },
    footer: {
      tag: "AS Roma 1982/83 · Cimelio autografato",
      city: "Roma, Italia",
      note: "Nessuna riproduzione. Nessun duplicato.",
    },
  },
  en: {
    nav: {
      story: "Story",
      manifesto: "Manifesto",
      gallery: "Gallery",
      contact: "Contact",
      langLabel: "IT / EN",
    },
    hero: {
      eyebrow: "A one-of-one relic · Rome, Italy",
      title1: "Twenty-two signatures.",
      title2: "One Scudetto.",
      title3: "A single photograph.",
      lede: "The full 1982/83 AS Roma squad — coaches, staff, and players — hand-signed on a single vintage print. Kept in Rome for over forty years.",
      cta: "Request information",
      scroll: "Scroll to discover",
    },
    marquee: "An irreplaceable relic — Un cimelio irripetibile — 1982/83 — Roma Italian Champions — ",
    manifesto: {
      eyebrow: "The manifesto",
      title: "Five chapters on a photograph that can no longer exist.",
      chapters: [
        {
          n: "01",
          title: "The object",
          body: "An official photographic print from the 1982/83 season, framed and never duplicated. On the front, the full squad poses for Foto Crescenzi's lens. Around the faces, twenty-two original autographs traced in black ink directly onto the photographic surface.",
        },
        {
          n: "02",
          title: "The Scudetto",
          body: "8 May 1983. Nils Liedholm's Roma wins the second league title in its history, forty-one years after the first. Falcão orchestrates the midfield, Bruno Conti draws lines on the wings, Agostino Di Bartolomei wears the armband. Eleven unbeaten matches close the season.",
        },
        {
          n: "03",
          title: "The signatures",
          body: "Every player, every coach, every member of the technical staff signed this photograph in person. Liedholm, Di Bartolomei, Falcão, Pruzzo, Bruno Conti, Ancelotti, Tancredi — a list that today contains names that can never again be added to anything.",
        },
        {
          n: "04",
          title: "The provenance",
          body: "The photograph has hung in a private home in Rome since the decade after the triumph. No signed reproductions were made. No second identical copy exists — the signatures are the unrepeatable imprint of a historic moment.",
        },
        {
          n: "05",
          title: "The uniqueness",
          body: "With the passing of some of the protagonists — Di Bartolomei, Liedholm, Vierchowod, Sébastien — this piece is now definitively irreplaceable. It is not a signed print: it is the only print that gathers all of these signatures together.",
        },
      ],
    },
    gallery: {
      eyebrow: "Gallery",
      title: "Five perspectives on the same relic.",
      captions: [
        "Front view · The complete frame",
        "Close-up · Third row and bench",
        "Top view · Starters' signatures",
        "Integral composition · Wooden frame",
        "Side view · Signatures highlighted",
      ],
    },
    signatures: {
      eyebrow: "The signatories",
      title: "Eleven starters, the bench, the coach. The full squad.",
      players: [
        "Franco Tancredi",
        "Sebino Nela",
        "Aldo Maldera",
        "Herbert Prohaska",
        "Michele Nappi",
        "Pietro Vierchowod",
        "Carlo Ancelotti",
        "Agostino Di Bartolomei",
        "Bruno Conti",
        "Roberto Pruzzo",
        "Paulo Roberto Falcão",
        "Odoacre Chierico",
        "Maurizio Iorio",
        "Ubaldo Righetti",
        "Franco Superchi",
        "Diego Bortoluzzi",
        "Stefano Desideri",
      ],
      staff: [
        "Nils Liedholm — Head Coach",
        "Ezio Sella — Assistant",
        "Giorgio Tessari — Second Coach",
        "Ernesto Colucci — Athletic Trainer",
        "Dr. Alicicco — Team Doctor",
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "For serious collectors.",
      body: "If you are interested in acquiring this piece, or wish to receive confidential information about provenance, authentication, and condition, write to me. I answer every message personally.",
      recipient: "francesco@cynopia.com",
      form: {
        name: "Full name",
        email: "Email",
        phone: "Mobile phone",
        message: "Your message",
        submit: "Send request",
        submitting: "Sending…",
        success: "Thank you. I will reply as soon as possible.",
        error: "Something went wrong. Please try again in a moment.",
      },
    },
    footer: {
      tag: "AS Roma 1982/83 · Autographed relic",
      city: "Rome, Italy",
      note: "No reproductions. No duplicates.",
    },
  },
};

export const detectLanguage = () => {
  if (typeof window === "undefined") return "it";
  const stored = window.localStorage.getItem("asroma_lang");
  if (stored === "it" || stored === "en") return stored;
  const nav = (window.navigator.language || "it").toLowerCase();
  return nav.startsWith("it") ? "it" : "en";
};
